<template>
    <v-container >
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <h1 class="mb-3 heading deep-purple--text text--accent-3">Uzņēmumi</h1>
                </v-flex>

                <v-spacer></v-spacer>

                <v-flex xs10 sm4 >
                    <v-text-field
                            @input="searchCompanies"
                            v-model="search"
                            append-icon="search"
                            label="Meklēt"
                            single-line
                            color="deep-purple accent-3"
                            class="mb-2"
                    ></v-text-field>
                </v-flex>
                <v-flex v-if="!showForm" xs2 sm1 class="pt-2 text-xs-right">
                    <v-tooltip top>
                        <v-btn  @click="showAddCompanyForm" small outline fab color="deep-purple" slot="activator">
                            <v-icon >add</v-icon>
                        </v-btn>
                        <span>Pievienot uzņēmumu</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-if="showForm" xs2 sm1 class="pt-2 text-xs-right">
                        <v-btn  @click="hideAddCompanyForm" small outline fab color="deep-orange lighten-1" slot="activator">
                            <v-icon >block</v-icon>
                        </v-btn>

                </v-flex>

            </v-layout>

        <add-company v-if="showForm"></add-company>

        <template v-if="companies">
            <v-card flat v-for="company in companies.data" :key="company.id">
                <v-layout row wrap class="pa-3 mb-1">
                    <v-flex xs12 md4>
                        <div class="caption grey--text">Nosaukums</div>
                        <div>{{company.name}}</div>
                    </v-flex>
                    <v-flex xs12 md3>
                        <div class="caption grey--text">Reģistrācijas Nr</div>
                        <div>{{company.reg_nr}}</div>
                    </v-flex>
                    <v-flex xs12 md4>
                        <div class="caption grey--text">Adrese</div>
                        <div>{{company.address}}</div>
                    </v-flex>

                    <v-flex xx12 sm4 md1>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon to="" flat small slot="activator">
                                        <v-icon color="grey">open_in_new</v-icon>
                                    </v-btn>
                                    <span>Skatīt uzņēmumu</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon @click="deleteCompany(company.id)" flat small slot="activator">
                                        <v-icon color="grey">delete</v-icon>
                                    </v-btn>
                                    <span>Dzēst uzņēmumu</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <v-layout row>
                <v-flex v-if="companies.meta.last_page > 1" sm6  offset-sm4>
                    <v-pagination
                            v-model="companies.meta.current_page"
                            :length="companies.meta.last_page"
                            :total-visible="5"
                            color="deep-purple accent-3"
                            @input="onPageChange"
                    ></v-pagination>
                </v-flex>
            </v-layout>
        </template>

        <v-snackbar
                v-model="snackbar"
                :color="color"
                :timeout="timeout"
                auto-height
                right
        >
            {{ text }}
            <v-btn dark
                   flat
                   @click="snackbar = false"
            >X</v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AddCompany from "../components/AddCompany.vue";

    export default {
        name: "Companies",
        components: {AddCompany},
        data: () => ({
            snackbar: false,
            color: '',
            timeout: 2000,
            text: ''
        }),
        mounted() {
            this.$store.dispatch('hideAddCompanyForm')
            this.$store.dispatch('resetSearch')
            this.$store.dispatch('getCompanies')
        },
        computed: {
            ...mapGetters({
                companies: 'companies',
                search: 'search',
                showForm: 'showAddCompanyForm'
            })
        },
        methods: {
            searchCompanies(value){
                this.$store.dispatch('changeSearch', value)
                this.$store.dispatch('getCompanies')
            },
            onPageChange() {
                this.$store.dispatch('getCompanies', this.companies.meta.current_page);
            },
            showAddCompanyForm(){
                this.$store.dispatch('showAddCompanyForm')
            },
            hideAddCompanyForm(){
                this.$store.dispatch('hideAddCompanyForm')
            },
            deleteCompany(companyId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteCompany', companyId)
                    this.snackbar = true
                    this.color = 'red'
                    this.text = 'Uzņēmums dzēsts'
                }
            }



        }
    }
</script>

<style scoped>

</style>